export default {"src":"/_next/static/media/disc-wheels.fd1af49f.svg","height":382,"width":556,"blurWidth":0,"blurHeight":0};